import React, {Component} from 'react';
import PerformanceBarPrize from './performance-bar-prize';
import PerformanceBarPoints from './performance-bar-points';

import './performance-bar.css';

class PerformanceBar extends Component {
  hasReachedTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.target
  }

  hasReachedBaseTarget() {
    const { incentive } = this.props;
    return incentive.packs_sold >= incentive.base_target
  }

  performanceBarBGColor() {
    if (this.hasReachedTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  performanceBaseTargetBarBGColor() {
    if (this.hasReachedBaseTarget()) {
      return '#70bd4d';
    }
    return '#ffc734';
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;
    return incentive.kind === 'base_target';
  }

  render() {
    return (
      this.props.incentive.reward_type === 'points' ? <PerformanceBarPoints incentive={this.props.incentive} /> : <PerformanceBarPrize incentive={this.props.incentive}/>
    );
  }
}

export default PerformanceBar;



// WEBPACK FOOTER //
// ./src/components/common/store-performances/performance-bar/performance-bar.jsx